export default __webpack_public_path__ + "assets/letter-component.29b717d6.svg";